(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-password-access"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openAccess = async (section) => {
      const component = section?.querySelector('dialog-component.atelier-access');
      if (!component) return;
      await customElements.whenDefined('dialog-component');
      if (component.isConnected) component.showDialog();
    };
    const initialize = (scope) => {
      scope.querySelectorAll('dialog-component.atelier-access').forEach((component) => {
        if (component.querySelector('[data-access-error]')) {
          openAccess(component.closest('.shopify-section'));
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else initialize(document);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });
    document.addEventListener('shopify:section:select', (event) => openAccess(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      openAccess(event.target.closest('.shopify-section'));
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const component = event.target.querySelector('dialog-component.atelier-access');
      if (component && typeof component.closeDialog === 'function') component.closeDialog();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
